// import './notFound.css';

function notFound() {
    return (
        <article className="container column">
            <h1 className="h0">404</h1>
            <h1 className="h0">Page Not Found</h1>
            <section className='flex column justify-content-cntr align-items-cntr margin-t-md width-75p'>
                <p className="font-md align-txt-cntr text-muted">We're sorry, the page you requested could not be found. Please go back to the homepage or contact us through the support page.</p>
                <div className='button-group margin-t-sm'>
                    <a className='button align-txt-cntr margin-sm' href='/support'><b>Support</b></a>
                    <a className='button align-txt-cntr' href="/"><b>Home</b></a>
                </div>
            </section>
        </article>
    );
}

export default notFound;